export const SHARE_COPY_TOOLTIP_DESKTOP_MIN_WIDTH = 768;

/** Header title area on the wide Copy/Share panel. */
export const SHARE_COPY_HEADER_TOOLTIP_CHAR_LIMIT = {
  desktop: 90,
  mobile: 22,
} as const;

/** Narrower company/user cells and the Users panel title. */
export const SHARE_COPY_CELL_TOOLTIP_CHAR_LIMIT = {
  desktop: 30,
  mobile: 18,
} as const;

export type ShareCopyOverflowTooltipSurface = 'header' | 'cell';

export const getShareCopyOverflowTooltipCharLimit = (
  viewportWidth: number,
  surface: ShareCopyOverflowTooltipSurface = 'header'
): number => {
  const limits =
    surface === 'header' ? SHARE_COPY_HEADER_TOOLTIP_CHAR_LIMIT : SHARE_COPY_CELL_TOOLTIP_CHAR_LIMIT;

  return viewportWidth > 0 && viewportWidth < SHARE_COPY_TOOLTIP_DESKTOP_MIN_WIDTH
    ? limits.mobile
    : limits.desktop;
};

export const shouldShowShareCopyOverflowTooltip = (
  text: string | null | undefined,
  viewportWidth: number,
  surface: ShareCopyOverflowTooltipSurface = 'header'
): boolean => {
  const value = text?.trim() ?? '';
  if (!value) {
    return false;
  }

  return value.length > getShareCopyOverflowTooltipCharLimit(viewportWidth, surface);
};

export const getShareCopyOverflowTooltipProps = (
  text: string | null | undefined,
  viewportWidth: number,
  surface: ShareCopyOverflowTooltipSurface = 'header',
  alwaysShow = false
): { 'data-tooltip-id': string; 'data-tooltip-content': string } | undefined => {
  const value = text?.trim() ?? '';
  if (!value) {
    return undefined;
  }

  if (!alwaysShow && !shouldShowShareCopyOverflowTooltip(value, viewportWidth, surface)) {
    return undefined;
  }

  return {
    'data-tooltip-id': 'global-tooltip',
    'data-tooltip-content': value,
  };
};
